export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/2259705187fd1dd45e0d0e44da297eb5.png";